// http api timeout options
export let timeouts = {
    // call api/init
    APP_INIT: 20000,
    // api/initDomain
    DOMAIN_INIT: 10000,
    // all other api/*
    API_DEFAULT: 10000,
    // all other
    DEFAULT: 30000,
    // auth/info (will trigger a API_OFFLINE state if invalidated)
    SERVER_INFO: 5000,
    // auth/login
    LOGIN: 5000,
    // handle timeout: Infinity
    MAX_TIMEOUT: 60000
} // timeouts = Object.fromEntries(Object.entries(timeouts).map(([k, v]) => [k, v / 100]))
;
